// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "(max-width: 768px)";
var _5 = "airplane-QpRXp";
var _6 = "airplane_noInfo-1GRkQ";
var _7 = "airplane__info-3jzSG";
var _8 = "airplane__info_wrapper-Q9Wgt";
var _9 = "airplane__name-3Vlde";
var _a = "airplane__amenities-1q7am";
var _b = "info-3HtSd";
var _c = "airplane__image-1UA88";
var _d = "details-3PLaX";
var _e = "details_one-H2e88";
var _f = "seatsDetails-sNRwU";
var _10 = "seatsDetails_icon-NfoUA";
var _11 = "modal-18A2k";
var _12 = "segment-14mzl";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "tabletMiddle", _5 as "airplane", _6 as "airplane_noInfo", _7 as "airplane__info", _8 as "airplane__info_wrapper", _9 as "airplane__name", _a as "airplane__amenities", _b as "info", _c as "airplane__image", _d as "details", _e as "details_one", _f as "seatsDetails", _10 as "seatsDetails_icon", _11 as "modal", _12 as "segment" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "tabletMiddle": _4, "airplane": _5, "airplane_noInfo": _6, "airplane__info": _7, "airplane__info_wrapper": _8, "airplane__name": _9, "airplane__amenities": _a, "info": _b, "airplane__image": _c, "details": _d, "details_one": _e, "seatsDetails": _f, "seatsDetails_icon": _10, "modal": _11, "segment": _12 }
